import { apiCall } from '../helpers/apiHelpers';
import { PassResetResponse } from '../types/api/responses';

export const passResetService = apiCall<PassResetResponse>({
  method: 'POST',
  url: '/client/refreshpassword',
});
